import { useMemo } from "react";

import { useLanguage } from "../../../../i18n/useLanguage";
import {
  AccessoryCategory,
  useSearchAccessoriesByVehicle,
} from "../../../../queries/useSearchAccessoriesByVehicle";
import { useAccesssoryCategories } from "./useAccesssoryCategories";

type CategoryOption = {
  checked: boolean;
  name: string;
  sortOrder: number;
  value: string;
};

export const useCategoryOptions = (): CategoryOption[] => {
  const [categories] = useAccesssoryCategories();
  const { data: results } = useSearchAccessoriesByVehicle();
  const [language] = useLanguage();

  const options = useMemo(() => {
    const nextCategories: Record<string, AccessoryCategory> = {};

    for (const { partDetails } of results?.partList || []) {
      const { accessoryCategories } = partDetails.primaryPart;
      for (const category of accessoryCategories) {
        Object.assign(nextCategories, category);
      }
    }

    return Object.entries(nextCategories)
      .map<CategoryOption>(([value, { sortOrder, ...category }]) => {
        const name: string = category[language] || category.en;
        const option = {
          checked: categories.includes(value),
          name,
          sortOrder: Number(sortOrder),
          value,
        };

        return option;
      })
      .sort((a, b) => a.sortOrder - b.sortOrder);
  }, [results, language, categories.toString()]);

  return options;
};
